var map = {
	"./Memory": 4114,
	"./Memory.js": 4114,
	"./MemorySoloGame": 9507,
	"./MemorySoloGame.js": 9507,
	"./SingleCard": 7795,
	"./SingleCard.js": 7795,
	"./assets/back.png": 8630,
	"./assets/imageeight.png": 3039,
	"./assets/imagefive.png": 7840,
	"./assets/imagefour.png": 8496,
	"./assets/imageone.png": 8386,
	"./assets/imageseven.png": 3349,
	"./assets/imagesix.png": 9182,
	"./assets/imagethree.png": 1846,
	"./assets/imagetwo.png": 964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504;